<template>
  <div>
    <v-simple-table v-if="!loading && paymentDetails && paymentDetails.length" dense>
      <template v-slot:default>
        <tbody>
        <template v-for="(pd, index) in paymentsDataFields[paymentMethodId]">
          <tr v-if="getPaymentDataValue(paymentDetails, pd.field)" :key="`paymentDetails-${payment.id}-${index}`">
            <td class="text-capitalize">{{pd.label}}</td>
            <td>{{getPaymentDataValue(paymentDetails, pd.field)}}</td>
          </tr>
        </template>
        </tbody>
      </template>
    </v-simple-table>
    <div v-else-if="loading" class="text-center">
      <v-progress-circular size="50" indeterminate color="primary"></v-progress-circular>
    </div>
    <p class="v-subheader h3" v-else>
      {{getMessage()}}
    </p>
  </div>
</template>

<script>
import paymentsDataFields from "@/utils/form.PaymentDetails";
import paymentsApi from "@/api/payments";

export default {
  name: "PaymentDetails",
  props: {
    payment: {
      type: Object,
    },
  },
  data() {
    return {
      paymentsDataFields,
      loading: false,
      paymentDetails: [],
    }
  },
  methods: {
    getMessage(){
      let msg = `This payment doesn't have payment information?`
      if (this.isTipalti){
         msg = 'Payment Details can be located inside Tipalti'
      }
      return msg
    },
    getPaymentDataValue(data, field) {
      const found = data.find(pd => pd.field === field);
      if (found) {
        return found.value;
      }

      return '';
    },
  },
  async mounted() {
    if (this.payment.id && !this.paymentDetails.length) {
      this.loading = true;
      try {
        this.paymentDetails = await paymentsApi.getPaymentDetails({
          paymentId: this.payment.id
        });
      } finally {
        this.loading = false;
      }
    }
  },
  computed: {
    paymentMethodId() {
      return this.payment.paymentTypeId;
    },
    isTipalti() {
      return this.payment.isPaymentMethodIsTipalti
    }
  }
}
</script>

<style scoped>

</style>
